<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_2"><span>Season’s Meetings</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent">by Ren Gold</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Shy web designer Kyle Zigler is resigned to living a solitary life as a single dad raising two gifted kids… until a sexy artist at a holiday market gives him a gift with delightful and unexpected consequences. Is he brave enough to open his heart again?</p>
<p class="P_Normal">Charming holiday vendor Vic Burgess has spent his entire life on the move, drifting wherever the wind blows to sell his handmade creations, when he meets a hunky young father who makes him feel like staying put. What will it take to make him stay?</p>
<p class="P_Normal">Two lonely lives colliding at Christmas…. Can a festive fling turn into something more? Find out in this heartwarming story of gay apparel, found family, and the magic of unexpected meetings.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?69de2959